import React from 'react';
import { mixpanel } from '@fiverr-private/obs';
import { Dropdown } from '@fiverr-private/orca';
import { Avatar } from '@fiverr-private/fit';
import { user } from '../../PropTypes';
import { ProfileMenu } from './ProfileMenu';

import styles from './BusinessProVisitorProfileDropdown.module.scss';

export const BusinessProVisitorProfileDropdown = (_props, { user }) => {
    const { username, profileImage } = user;

    const onOpen = () => {
        mixpanel.track('Clicked avatar menu on visitor header');
    };

    return (
        <Dropdown
            containerClassName={styles.menuContainer}
            onOpen={onOpen}
            position={Dropdown.POSITIONS.RIGHT}
            menu={<ProfileMenu />}
        >
            <div>
                <Avatar username={username} src={profileImage} size={32} />
            </div>
        </Dropdown>
    );
};

BusinessProVisitorProfileDropdown.contextTypes = {
    user,
};
